export default __webpack_public_path__ + "static/VP_Approach-f51e490752742fba6ca1d0ec14225434.mp4";